// extracted by mini-css-extract-plugin
export default {"container":"Integrations_container__Uba8N","title":"Integrations_title__fHNZL","methods":"Integrations_methods__tX547"};